import { render } from "./hotel_rating.vue?vue&type=template&id=6fdd9d7e"
import script from "./hotel_rating.vue?vue&type=script&lang=js"
export * from "./hotel_rating.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__